import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';

export const fetchAllTrainingReport = createAsyncThunk(
    'report/fetchAllUserReport',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/report/training');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all training Report');
        }
    }
);
export const fetchAllTrainingReportMonthly = createAsyncThunk(
    'report/fetchAllUserReport',
    async (year : string , { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/training/monthly/${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Training Report');
        }
    }
);
export const fetchAllUpcomingEvents = createAsyncThunk(
    'report/fetchAllUserReport',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/training/upcomingtraining`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Training Events');
        }
    }
);
export const fetchAllDuration = createAsyncThunk(
    'report/fetchAllUserReport',
    async (year : string, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/training/duration/${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Duration');
        }
    }
);